// extracted by mini-css-extract-plugin
module.exports = {"videoContainer":"YoutubePlayer_videoContainer__XWPEq","video":"YoutubePlayer_video__KCPT_"};